<!-- <div class="numeric-field-container">
  <label *ngIf="label" [for]="id" class="mb-2 global-form-field">{{ label | translate }} <span class="text-danger fw-bold" *ngIf="required">*</span></label>
  <input 
    type="text"
    [id]="id"
    class="form-control"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (keypress)="handleKeyPress($event)"
    (paste)="$event.preventDefault()"
    style="height: 40px; font-size: 14px; border-radius: 6px; border: 1px solid #ced4da;"
  />
</div> -->


<div class="numeric-field-container mb-3">
  <label *ngIf="label" [for]="id" class="mb-2 global-form-field">{{ label | translate }} <span class="text-danger fw-bold" *ngIf="required">*</span></label>
  
  <input 
    type="text"
    [id]="id"
    [disabled]="disabled"
    class="form-control"
    [placeholder]="placeholder || ''"
    [ngModel]="innerValue"
    (ngModelChange)="onInputChange($event)"
    (keypress)="handleKeyPress($event)"
    (paste)="handlePaste($event)"
    (blur)="onTouch()"
    style="height: 40px; font-size: 14px; border-radius: 6px; border: 1px solid #ced4da;"
  />
</div>